import { NgModule } from '@angular/core';
import { TutoringInfoSectionComponent } from './tutoring-info-section/tutoring-info-section.component';
import { TutorCardsComponent } from './tutor-cards/tutor-cards.component';
import { TextInfoSectionComponent } from './text-info-section/text-info-section.component';
import { InfoTextComponent } from './info-text/info-text.component';
import { InfoPopupComponent } from './info-popup/info-popup.component';
import { InfoImageComponent } from './info-image/info-image.component';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { LocalizePipe } from '../../localize/localize.pipe';
import { TranslateModule } from '@ngx-translate/core';
import { BindHTMLDirective } from '../shared/directives/bindHTML.directive';
import { ModalComponent } from '../shared/modal/modal.component';
import { VideoComponent } from '../shared/video/video/video.component';

@NgModule({
	declarations: [
		InfoPopupComponent,
		InfoImageComponent,
		InfoTextComponent,
		TextInfoSectionComponent,
		TutorCardsComponent,
		TutoringInfoSectionComponent
	],
	imports: [
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		RouterModule,
		LocalizePipe,
		TranslateModule,
		BindHTMLDirective,
		ModalComponent,
		VideoComponent,
	],
	exports: [
		InfoPopupComponent,
		InfoImageComponent,
		InfoTextComponent,
		TextInfoSectionComponent,
		TutorCardsComponent,
		TutoringInfoSectionComponent
	]
})
export class InfoModule { }
